import staticLogo from "./images/logo.png";
export const siteLogo = process.env.REACT_APP_SITE_LOGO || staticLogo;

//url's
export const home = "/";
export const about = "/about";
export const login = "/login";
export const signup = "/signup";
export const userDashboard = "/user-dashboard";
export const contact = "/contact";
export const termAndCondition = "/term-and-conditions";
export const privacyPolicy = "/privacy-policy";
export const dashboard = "/dashboard";
export const users = "/users";
export const chatUsers = "/chat-users";
export const chatWithAgent = "/agent-to-agent";
export const quickChat = "/quick-chat";
export const chat = "/chat";
export const verifyOtp = "/verify-otp";
export const settings = "/settings";
export const branchs = "/branchs";
export const quickReply = "/quick-reply";
export const broadcast = "/broadcast";
export const messages = "/messages";
export const uploadedFiles = "/uploaded-files";
export const userprofile = "/user-profile";
export const notifications = "/notifications";


export const currentUrl = window.location.href;
// common Functions
export const productRating = (times) => {
  var repeatedString = "";
  while (times > 0) {
    repeatedString += "⭐";
    times--;
  }
  return (
    <ul
      dangerouslySetInnerHTML={{ __html: !!repeatedString && repeatedString }}
    />
  );
};
export const dynamicPriceRange = (price) => {
  const keys = Object.keys(price);
  const lastKey = keys[keys.length - 1];
  const lastValue = price[lastKey];
  return lastValue
}

  export const authToken = localStorage.getItem('x-auth-token');
  export const authSlug = localStorage.getItem('slug');
  export const authUserid = localStorage.getItem('userid');
  export const socketId = localStorage.getItem('socketid');

  export const isImage = (url) => {
    return /\.(jpeg|jpg|png|gif|bmp|webp|svg)$/i.test(url);
  };
  
  export const isVideo = (url) => {
    return /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(url);
  };
  
  export const isAudio = (url) => {
    return /\.(mp3|wav|ogg|m4a|aac|flac|webm)$/i.test(url);
  };

  export const getAudioMimeType = (fileUrl = "", fileType = "") => {
    if (fileType?.startsWith("audio/")) {
      return fileType;
    }

    const extension = fileUrl.split(".").pop()?.toLowerCase();

    switch (extension) {
      case "mp3":
        return "audio/mpeg";
      case "wav":
        return "audio/wav";
      case "ogg":
        return "audio/ogg";
      case "m4a":
        return "audio/mp4";
      case "aac":
        return "audio/aac";
      case "flac":
        return "audio/flac";
      case "webm":
      default:
        return "audio/webm";
    }
  };
  
